var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"theme":"light"}},[_c('HeaderComponents'),_c('Content',{staticClass:"privacy-policy-page"},[_c('div',{staticClass:"privacy-policy-content",domProps:{"innerHTML":_vm._s(_vm.privacy_policy)}})]),_c('FooterComponents')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }